import { useQuery } from 'react-query'

import { getLatestBlockChanges } from 'api/blocks'

export const useLatestMajorBlockChanges = (blockId: string) => {
  const { data } = useQuery(`latest-major-block-changes--${blockId}`, () =>
    getLatestBlockChanges(blockId).then(({ data }) => data)
  )

  return data
}
